:host {
  --uui-radio-font-family: var(--uui-primary-font-family);
  --uui-radio-label-color: var(--uui-theme-on-background);
  --uui-radio-color: var(--uui-theme-on-background);
  --uui-radio-bg-color: var(--uui-theme-tertiary-600);
  --uui-radio-border-color: var(--uui-radio-color);
  --uui-radio-border-hover-color: var(--uui-theme-core-400);
  --uui-radio-border-width: 1px;
  --uui-radio-border-checked-width: 4px;
  --uui-radio-border-active-width: 2px;
  --uui-radio-border-checked-color: var(--uui-theme-core-600);
  --uui-radio-bg-checked-color: var(--uui-theme-core-600);
  --uui-radio-inner-color: var(--uui-on-core-700);
  --uui-radio-button-font-size: var(--uui-default-font-size);
  --uui-radio-box-shadow: inset 0 0 0 2.5px var(--uui-box-shadow-color);
}

:host {
  font-family: var(--uui-primary-font-family);
  color: var(--uui-radio-color);
  font-size: var(--uui-radio-button-font-size);
}

:host[error] {
  --uui-radio-color: var(--uui-theme-error-600);
  --uui-radio-label-color: var(--uui-theme-error-600);
  --uui-radio-border-color: var(--uui-theme-error-600);

  --uui-radio-hover-color: var(--uui-theme-error-600);
  --uui-radio-bg-hover-color: var(--uui-theme-error-600);
  --uui-radio-border-hover-color: var(--uui-theme-error-600);

  --uui-radio-active-color: var(--uui-theme-error-600);
  --uui-radio-bg-active-color: var(--uui-radio-active-color);
  --uui-radio-border-active-color: var(--uui-radio-active-color);

  --uui-radio-checked-color: var(--uui-radio-color);
  --uui-radio-bg-checked-color: var(--uui-radio-color);
  --uui-radio-border-checked-color: var(--uui-radio-checked-color);
}

input[type="radio"] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  box-sizing: border-box;
}

input[type="radio"] + label {
  position: relative;
  display: flex;
  line-height: 1.5em;
  font-size: 1em;
  vertical-align: middle;
  box-sizing: border-box;
}

input[type="radio"] + label {
  color: var(--uui-radio-label-color);
}

/* enabled state */
input[type="radio"] + label::before {
  flex: none;
  box-sizing: border-box;
  content: "";
  width: 1.5em;
  display: inline-block;
  margin-right: 0.625em;
  height: 1.5em;
  cursor: pointer;
  text-align: center;
  vertical-align: bottom;
  border-radius: 100%;
}

input[type="radio"] + label:hover::before {
  cursor: pointer;
}

input[type="radio"]:checked + label::before {
  box-sizing: border-box;
}

input[type="radio"]:focus + label::before,
input[type="radio"]:checked:focus + label::before,
input[type="radio"].error:focus + label::before,
input[type="radio"].error:checked:focus + label::before {
  outline: none;
}

/* disabled state */
input[type="radio"]:disabled + label {
  pointer-events: none;
  opacity: var(--uui-disabled-opacity);
}

input[type="radio"] + label::before {
  border-style: solid;
  border-width: var(--uui-radio-border-width);
  border-color: var(--uui-radio-border-color);
  background-color: var(--uui-radio-bg-color);
}

input[type="radio"] + label:hover::before {
  border-width: var(--uui-radio-border-active-width);
  border-color: var(--uui-radio-border-hover-color);
}

input[type="radio"]:checked + label::before {
  background-color: var(--uui-radio-bg-checked-color);
  border-color: var(--uui-radio-border-checked-color);
  border-width: var(--uui-radio-border-checked-width);
  box-shadow: var(--uui-radio-box-shadow);
}

input[type="radio"]:active + label:before {
  border-width: var(--uui-radio-border-active-width);
}

input[type="radio"]:checked + label:hover::before {
  border: 4px solid var(--uui-radio-border-checked-color);
}

input[type="radio"]:focus + label::before {
  border: 2px solid var(--uui-radio-color);
}

input[type="radio"]:checked:focus + label::before {
  border: 4px solid var(--uui-radio-border-checked-color);
}

input[type="radio"] + label:hover {
  cursor: pointer;
}

[error] input[type="radio"] + label::before {
  border: 1px solid var(--uui-color-error-dark);
}

input[type="radio"].error + label:hover::before {
  border-width: var(--uui-radio-border-active-width);
  border-color: var(--uui-color-error-dark);
  color: var(--uui-theme-color-error-400);
}

input[type="radio"].error:checked + label::before {
  background-color: var(--uui-color-error-dark);
  box-shadow: inset 0 0 0 2.5px rgba(255, 255, 255, 0.95);
  border: 4px solid var(--uui-color-error-dark);
}

input[type="radio"].error:focus + label::before {
  border: 2px solid var(--uui-color-error-dark);
}

input[type="radio"].error:checked:focus + label::before {
  border: 4px solid var(--uui-color-error-dark);
}

input[type="radio"].error + label {
  color: var(--uui-color-error-dark);
}
